import React, { useEffect, useState } from "react";
import { Bar } from "@ant-design/plots";
import styled from "@emotion/styled";
import { Spin, Select, Form, } from "antd";

// Redux
import {
  getUserRoleId,
  getSelectedDepartmentId,
  getClientid,
  getLeaveCategoryList,
  getAllDepartmentList,
  getUserList,
  getIsCheckedIn,
  getUserInfo,
} from "redux/selectors";
import DepartmentAttendanceReport from "./DepartmentAttendanceReport";
import AttendanceStaffList from "./AttendanceStaffList";
import { CALL_API } from "common/API";
import { concat, isNaN, map, max, size, includes, some } from "lodash";
import { uniqBy } from "lodash";
import { connect, useSelector } from "react-redux";
import { STATUS_CODE, CountryFilterResourcePlanning } from "common/Constants";


const StyledChartContainer = styled.div`
  padding: 20px !important;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px;
  border-radius: 8px !important;
  height: 100%;
  .name-title {
    padding: 3px 10px;
    font-size: 1rem;
    padding-bottom: 15px;
    font-weight: 600;
  }
`;

function AttendanceBarChart({
  userRoleId,
  selectedDepartmentId,
  ClientId,
  leaveCategoryList,
  allDepartmentList,
  userList,
  isCheckedIn,
  isHrDashboard = false,
  myTeam = false,
  getSubordinates,
  userInfo,
  managingoffice,
  isMyTeam
}) {
  const [
    displayDepartmentAttendanceReportModal,
    toggleDepartmentAttendanceReportModal,
  ] = useState(false);
  const [displayAttendanceStaffModal, toggleDisplayAttendanceStaffModal] = useState(false);
  const [reportType, setReportType] = useState("");
  const [reportName, setReportName] = useState("");
  const [reportList, setReportList] = useState([]);
  const [reportColor, setReportColor] = useState("");
  const [attendanceReportTitle, setAttendanceReportTitle] = useState("");
  const [displayReportLoader, toggleReportLoader] = useState(false);
  const [absentList, setAbsentList] = useState([]);
  const [lateListData, setLateListData] = useState([]);
  const [onTimeList, setOnTimeList] = useState([]);
  const [leaveList, setLeaveList] = useState([]);
  const [form] = Form.useForm();



  const [reportData, setReportData] = useState([
    {
      name: "onTime",
      type: "Present",
      numbers: 0,
      list: [],
    },
    {
      name: "Absent",
      type: "Absent",
      numbers: 0,
      list: [],
    },

    {
      name: "Late",
      type: "Present",
      numbers: 0,
      list: [],
    },
    {
      name: "Leave",
      type: "leave",
      numbers: 0,
      list: [],
    },

  ]);
  const config = {
    isStack: true,
    data: reportData,
    dodgePadding: 0.2,
    intervalPadding: 10,
    height: 400,
    xField: "numbers",
    yField: "type",
    seriesField: "name",
    legend: false,
    color: ({ name }) => {
      if (name === "Absent") {
        return "orange";
      } else if (name === "onTime") {
        return "#0565f5";
      } else if (name === "Late") {
        return "#5d9af5";
      } else if (name === "Leave") {
        return "#bd34eb";
      } else {
        return "#f5e0ff";
      }
    },
    theme: {
      maxColumnWidth: 50,
      minColumnWidth: 50,
    },

    label: {
      position: "middle",
      content: "",
    },
    columnStyle: {
      cursor: "pointer",
    },
    xAxis: {
      max: isNaN(max(map(reportData, "numbers")))
        ? 100
        : max(map(reportData, "numbers")) + 15,
      grid: {
        line: {
          style: {
            opacity: 0,
          },
        },
      },
    },
  };

  const annualLeaveCategoryId = leaveCategoryList.find(
    (item) => item.leave_category_short_name === "annualleave"
  );
  const sickLeaveCategoryId = leaveCategoryList.find(
    (item) => item.leave_category_short_name === "sickleave"
  );

  useEffect(() => {
    if (
      (userRoleId !== 1 && selectedDepartmentId !== 0) ||
      userRoleId === 1 ||
      userRoleId === 6
    ) {
      getReportData();
    }
  }, []);

  const filteruser = userList?.filter(
    (item) => item?.userid === userInfo.userid
  );
  const [selectedManagingOffice, setSelectedManagingOffice] = useState(filteruser[0]?.managingoffice);

  useEffect(() => {
    getReportData();
  }, [managingoffice]); // 👈 API will run whenever dropdown changes


  const getReportData = async () => {
    toggleReportLoader(true);
    if (ClientId) {
      const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
      await delay(100);

      // Generate the team tree
      let subOrdinatesList = [""];

      if (myTeam) {
        const subOrdinates = [...new Set(getSubordinates(myTeam))];
        subOrdinatesList = subOrdinates?.length > 0 ? subOrdinates : [""];
      } else if (isHrDashboard) {
        subOrdinatesList = [""];
      }
      const { todayAttendenceDetails } = await CALL_API(
        `attendance-service/${ClientId}`,
        "post",
        {
          // departmentId:
          //   userRoleId != 1 && userRoleId != 6 ? selectedDepartmentId : [""],
          officesupervisorid: myTeam
            ? filteruser?.OfficeSupervisorId === "none"
              ? [""]
              : [filteruser[0]?.employeeid]
            : [""],
          country: myTeam ? "" : selectedManagingOffice ? (Array.isArray(selectedManagingOffice) && selectedManagingOffice.length > 0 ? selectedManagingOffice : [selectedManagingOffice]) : filteruser[0]?.managingoffice,
        }
      );
      let absentList = [];
      let ontimeList = [];
      let lateList = [];
      let leaveList = [];
      todayAttendenceDetails?.forEach((value) => {

        ontimeList = value.onTime;
        lateList = value?.late;
        absentList = value?.absent;
        leaveList = value?.leaveCount;
      });

      let dupeReportData = [...reportData];

      dupeReportData[0].numbers = size(ontimeList);
      dupeReportData[1].numbers = size(absentList);
      dupeReportData[2].numbers = size(lateList);
      dupeReportData[3].numbers = size(leaveList);
      dupeReportData[0].list = ontimeList;
      dupeReportData[1].list = absentList;
      dupeReportData[2].list = lateList;
      dupeReportData[3].list = leaveList;

      setReportData(dupeReportData);
      toggleReportLoader(false);
      setAbsentList(absentList);
      setLateListData(lateList);
      setOnTimeList(ontimeList);
      setLeaveList(leaveList);
    }
  };



  const handleFormChange = (value) => {
    setSelectedManagingOffice(value || "");
  };

  useEffect(() => {
    if (selectedManagingOffice !== undefined) {
      getReportData();
    }
  }, [selectedManagingOffice]);



  return (
    <>
      <StyledChartContainer>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div className="name-title">Today's Overall Attendance</div>

          {filteruser[0]?.roleid?.includes("2") && !isMyTeam && (
            <Select
              showSearch
              placeholder="Select Country"
              labelInValue
              style={{ width: 200 }}
              onChange={(option) => {
                form.setFieldsValue({ managingoffice: option });
                handleFormChange(option.label);
              }}
            >
              {uniqBy(
                CountryFilterResourcePlanning?.map((item) => ({
                  label: item.country,
                  value: item.country,
                })),
                "value"
              )?.map((option) => (
                <Select.Option key={option.value} value={option.value}>
                  {option.label}
                </Select.Option>
              ))}
            </Select>

          )}

        </div>

        <Spin spinning={displayReportLoader}>
          <Bar
            {...config}
            onReady={(plot) => {
              plot.on("plot:click", (evt) => {
                if (evt.data && evt.data.data !== null) {
                  const {
                    data: {
                      data: { type, list, name },
                      color,
                    },
                  } = evt;
                  setReportList(list);
                  setReportType(type);
                  setReportName(name);
                  if (userRoleId !== "1") {
                    setAttendanceReportTitle(`${type} staff`);
                    toggleDisplayAttendanceStaffModal(true);
                  }
                }
              });
            }}
          />
        </Spin>
      </StyledChartContainer>
      <DepartmentAttendanceReport
        displayModal={displayDepartmentAttendanceReportModal}
        toggleModal={() => toggleDepartmentAttendanceReportModal(false)}
        reportType={reportType}
        reportColor={reportColor}
        list={reportList}
        name={reportName}
        lateListData={lateListData}
        onTimeList={onTimeList}
        leaveList={leaveList}
        absentList={absentList}
      />
      <AttendanceStaffList
        displayModal={displayAttendanceStaffModal}
        toggleModal={() => toggleDisplayAttendanceStaffModal(false)}
        title={attendanceReportTitle}
        reportType={reportType}
        list={reportList}
        name={reportName}
        isHrDashboard={isHrDashboard}
        userInfo={userInfo}
      />
    </>
  );
}

const mapStateToProps = (state) => ({
  userRoleId: getUserRoleId(state),
  selectedDepartmentId: getSelectedDepartmentId(state),
  ClientId: getClientid(state),
  leaveCategoryList: getLeaveCategoryList(state),
  allDepartmentList: getAllDepartmentList(state),
  userList: getUserList(state),
  isCheckedIn: getIsCheckedIn(state),
  userInfo: getUserInfo(state),
});

export default connect(mapStateToProps, null)(AttendanceBarChart);